import * as React from 'react';

type Props = {
  src?: string;
  strategy?: string;
  id?: string;
  children?: string;
} & React.HTMLAttributes<HTMLScriptElement>;

export default function Script({ src, id, children }: Props) {
  React.useEffect(() => {
    if (!src && !children) return;

    // Avoid duplicates
    if (id && document.getElementById(id)) return;

    const script = document.createElement('script');
    if (id) script.id = id;
    if (src) {
      script.src = src;
      script.async = true;
    } else if (children) {
      script.text = children;
    }
    document.head.appendChild(script);

    return () => {
      // Keep scripts persistent; removing can break analytics/third-party libs
    };
  }, [src, id, children]);

  return null;
}

